import { getStream } from '../base/selectors';
function getCursorStream(state, streamId) {
    return getStream(state, streamId);
}
export var getCursor = function (state, streamId) {
    return getCursorStream(state, streamId).cursor;
};
export var getPrevCursor = function (state, streamId) {
    return getCursorStream(state, streamId).prevCursor;
};
//# sourceMappingURL=selectors.js.map